const translations = {
  // ── Client Portal ──
  'client.portal.yourProject': '您的项目',
  'client.portal.noProjectLinked': '未关联项目',
  'client.portal.noProjectDesc': '您的账户尚未关联任何项目。Japan Homes 将在项目设置完成后在此处连接您的项目。',
  'client.portal.latestFromJH': 'Japan Homes 最新动态',
  'client.portal.latestFromJHDesc': '重要的项目信息、审批、每日日志、付款、文件和通知将显示在相关部分。',
  'client.portal.actionItems': '待办事项',
  'client.portal.actionItemsDesc': '任何需要您输入的事项——例如指示、付款审批或决策——将显示在此处。请在相关部分查看更新。',
  'client.portal.instructions': '指示',
  'client.portal.instructionsDesc': '决策与审批',
  'client.portal.askQuestion': '提问',
  'client.portal.askQuestionDesc': 'Japan Homes 将回复您',
  'client.portal.projectFiles': '项目文件',
  'client.portal.projectFilesDesc': '查看照片、文档和共享文件。',
  'client.portal.viewFiles': '查看文件',
  'client.portal.buildJourney': '您的建造旅程',
  'client.portal.noStagesYet': '项目阶段设置完成后将显示在此处。',
  'client.portal.projectDetails': '项目详情',
  'client.portal.managedBy': '管理方',
  'client.portal.projectCode': '项目代码',
  'client.portal.estCompletion': '预计完工',
  'client.portal.status': '状态',
  'client.portal.type': '类型',
  'client.portal.projectProgress': '项目进度',
  'client.portal.checklistFinal': '检查清单完成度',
  'client.portal.scheduleFinal': '进度表完成度',
  'client.portal.completed': '已完成',
  'client.portal.inProgress': '进行中',
  'client.portal.done': '完成',
  'client.portal.upcoming': '即将开始',
  'client.portal.delayed': '延迟',
  'client.portal.notStarted': '未开始',
  'client.portal.onHold': '暂停',
  'client.portal.refreshing': '刷新中...',
  'client.portal.complete': '{percent}% 完成',
  'client.portal.stagesCount': '{completed}/{total} 阶段',
  'client.portal.currently': '当前: {stage} · {percent}% 完成',
  'client.portal.projectCompleted': '项目已完成',
  'client.portal.itemsCompleted': '{done}/{total} 项已完成',
  'client.portal.datesTBC': '待定',

  // ── Portal Tabs ──
  'client.tab.myProject': '我的项目',
  'client.tab.schedule': '进度表',
  'client.tab.checklist': '检查清单',
  'client.tab.files': '文件',
  'client.tab.notifications': '通知',
  'client.tab.projectProgramme': '项目计划',
  'client.tab.programmeDesc': '这是您项目的计划进度表。如有任何疑问，请联系 Japan Homes。',
  'client.tab.projectChecklist': '项目检查清单',
  'client.tab.checklistDesc': '查看并确认您项目的已完成事项。',
  'client.tab.dailyLog': '日志',
  'client.tab.dailyLogDesc': 'Japan Homes 分享的施工现场照片和每日进度更新。',
  'client.tab.changeOrders': '变更单',

  // ── Client Change Orders ──
  'client.changeOrders.empty': '暂无变更单。',
  'client.changeOrders.emptyDesc': '当项目范围、规格或价格发生变更时，Japan Homes 将在此处分享变更单。',
  'client.changeOrders.pageDesc': '查看您项目的变更单、价格更新和审批。',
  'client.changeOrders.tabDesc': 'Japan Homes 与您分享的变更单和价格更新。',
  'client.changeOrders.attachments': '附件',
  'client.changeOrders.approvalPending': '等待您的审批',
  'client.changeOrders.approvalApproved': '已批准',
  'client.changeOrders.approvalDeclined': '已拒绝',
  'client.changeOrders.approvalNotRequired': '供您参考',
  'client.changeOrders.loadError': '加载变更单失败',

  // ── Client Daily Log ──
  'client.dailyLog.title': '每日日志',
  'client.dailyLog.siteUpdates': '每日现场更新',
  'client.dailyLog.siteUpdatesDesc': 'Japan Homes 分享的现场进度照片',
  'client.dailyLog.dailySiteUpdates': '每日现场更新',
  'client.dailyLog.dailySiteUpdatesDesc': '这些照片由 Japan Homes 精选并分享，让您随时了解项目进度。',
  'client.dailyLog.noSiteUpdates': '暂无现场更新',
  'client.dailyLog.noSiteUpdatesDesc': 'Japan Homes 将在施工过程中在此处分享现场照片和每日进度更新。',
  'client.dailyLog.noPhotos': '暂无照片。施工开始后将显示在这里。',
  'client.dailyLog.photoUnavailable': '照片不可用',

  // ── Client Instructions ──
  'client.instructions.title': '指示',
  'client.instructions.instructionsDecisions': '指示与决策',
  'client.instructions.instructionsDesc': '需要您审批的订单变更、变更项和决策',
  'client.instructions.pending': '{count} 个待处理',
  'client.instructions.noInstructions': '暂无指示',
  'client.instructions.noInstructionsDesc': 'Japan Homes 将在此处分享订单变更、变更项和重要决策。',
  'client.instructions.reason': '原因:',
  'client.instructions.cost': '费用:',
  'client.instructions.schedule': '进度:',
  'client.instructions.yourResponse': '您的回复',
  'client.instructions.approve': '批准',
  'client.instructions.decline': '拒绝',
  'client.instructions.confirmApproval': '确认批准',
  'client.instructions.confirmDecline': '确认拒绝',
  'client.instructions.approveChangeOrder': '批准此变更单?',
  'client.instructions.declineChangeOrder': '拒绝此变更单?',
  'client.instructions.optionalComment': '可选评论...',
  'client.instructions.cancel': '取消',
  'client.instructions.price': '价格：',
  'client.instructions.currentFinish': '当前：',
  'client.instructions.newFinish': '新：',

  // ── Client Payments ──
  'client.payments.title': '付款',
  'client.payments.paymentSchedule': '付款计划',
  'client.payments.noPayments': '暂无付款计划',
  'client.payments.noPaymentsDesc': 'Japan Homes 将很快为您设置付款计划。',
  'client.payments.totalScheduled': '计划总金额',
  'client.payments.paid': '已付款',
  'client.payments.remaining': '剩余金额',
  'client.payments.overdue': '逾期',
  'client.payments.dueNow': '到期',
  'client.payments.pending': '待处理',
  'client.payments.onTrack': '正常',
  'client.payments.amount': '金额',
  'client.payments.dueDate': '到期日',
  'client.payments.confirmPayment': '确认付款',
  'client.payments.confirming': '确认中…',
  'client.payments.youConfirmed': '您已确认此付款',
  'client.payments.confirmedByJH': 'Japan Homes 已确认',
  'client.payments.failedToLoad': '加载付款计划失败',
  'client.payments.gstNote': '所有金额以{currency}计价，如适用已包含GST。如有疑问请联系 Japan Homes。',
  'client.payments.attention': '注意',
  'client.payments.paymentOverdue': '逾期 {count} 笔',
  'client.payments.paymentDue': '到期 {count} 笔',
  'client.payments.makePayment': '请完成付款并点击「确认付款」通知 Japan Homes。',

  // ── Client Questions ──
  'client.questions.title': '问题',
  'client.questions.yourQuestions': '您的问题',
  'client.questions.askDesc': '关于您的项目，向 Japan Homes 提出任何问题',
  'client.questions.ask': '提问',
  'client.questions.client': '客户',
  'client.questions.management': '管理方',
  'client.questions.questionTitle': '问题标题',
  'client.questions.questionPlaceholder': '例如: 厨房瓷砖颜色',
  'client.questions.details': '详情',
  'client.questions.detailsPlaceholder': '请详细描述您的问题...',
  'client.questions.attachments': '附件',
  'client.questions.addFiles': '添加文件 (JPG, PNG, PDF)',
  'client.questions.filesUploaded': '文件在提交前已上传',
  'client.questions.noQuestions': '暂无问题',
  'client.questions.noQuestionsDesc': '向 Japan Homes 提问后，回复将显示在这里。',
  'client.questions.clientQuestion': '客户提问',
  'client.questions.answered': '已回答',
  'client.questions.open': '待回答',
  'client.questions.awaitingResponse': '等待 Japan Homes 回复',
  'client.questions.japanHomesReply': 'Japan Homes 回复',
  'client.questions.send': '发送',

  // ── Client Updates ──
  'client.updates.title': '更新',
  'client.updates.latestSitePhotos': '最新现场照片',
  'client.updates.projectUpdates': '项目更新',
  'client.updates.noUpdates': '暂无更新',
  'client.updates.noUpdatesDesc': 'Japan Homes 将在项目进展过程中在此处发布更新。',
  'client.updates.noPhotosYet': '暂无照片。施工开始后将显示在这里。',
  'client.updates.commentOnUpdate': '对此更新发表评论',
  'client.updates.hideComments': '隐藏评论',
  'client.updates.loadingComments': '加载评论中...',
  'client.updates.comments': '{count} 条评论',
  'client.updates.reply': '回复',
  'client.updates.cancelReply': '取消回复',
  'client.updates.writeReply': '写回复...',
  'client.updates.leaveComment': '给 Japan Homes 留言或提问...',
  'client.updates.comment': '评论',
  'client.updates.japanHomes': 'Japan Homes',

  // ── Client Notifications ──
  'client.notifications.title': '通知',
  'client.notifications.all': '全部',
  'client.notifications.unread': '未读',
  'client.notifications.markAllRead': '全部标为已读',
  'client.notifications.noNotifications': '暂无通知',
  'client.notifications.noNotificationsDesc': 'Japan Homes 发布更新后，通知将显示在这里',
  'client.notifications.allCaughtUp': '全部已读!',
  'client.notifications.noUnread': '没有未读通知',

  // ── Embed: Daily Log ──
  'embed.dailyLog.infoBanner': '每日现场更新',
  'embed.dailyLog.infoBannerDesc': '这些照片由 Japan Homes 精选并分享，让您随时了解项目进度。',
  'embed.dailyLog.noSiteUpdates': '暂无现场更新',
  'embed.dailyLog.noSiteUpdatesDesc': 'Japan Homes 将在施工过程中在此处分享现场照片和每日进度更新。',

  // ── Embed: Instructions ──
  'embed.instructions.noInstructions': '暂无指示',
  'embed.instructions.noInstructionsDesc': 'Japan Homes 将在此处分享订单变更、变更项和重要决策。',
  'embed.instructions.pendingDecisions': '{count} 个待决策',
  'embed.instructions.pendingDecisionsDesc': '请查看并批准或拒绝以下项目。',

  // ── Embed: Notifications ──
  'embed.notifications.viewAll': '查看全部通知',

  // ── Embed: Updates ──
  'embed.updates.noUpdates': '暂无更新',
  'embed.updates.noUpdatesDesc': 'Japan Homes 将在项目进展过程中在此处发布更新。',
  'embed.updates.noPhotos': '暂无照片。施工开始后将显示在这里。',

  // ── Common Status Labels ──
  'status.open': '未处理',
  'status.inReview': '审核中',
  'status.resolved': '已解决',
  'status.pending': '待处理',
  'status.approved': '已批准',
  'status.declined': '已拒绝',
  'status.acknowledged': '已确认',
  'status.completed': '已完成',
  'status.sent': '已发送',
  'status.awaitingApproval': '等待批准',
  'status.closed': '已关闭',
  'status.due': '到期',
  'status.overdue': '逾期',
  'status.upcoming': '即将到来',
  'status.paid': '已付款',
  'status.confirmed': '已确认',
  'status.awaitingReview': '等待审核',

  // ── Common Type Labels ──
  'type.orderChange': '订单变更',
  'type.variation': '变更项',
  'type.approvalRequest': '需要审批',
  'type.instruction': '指示',
  'type.designDecision': '设计决策',
  'type.payment': '付款',
  'type.scheduleChange': '进度变更',
  'type.changeOrder': '变更单',
  'type.progressUpdate': '进度更新',
  'type.question': '问题',
  'type.issueReport': '问题报告',
  'type.completion': '已完成',

  // ── Common Actions ──
  'common.readMore': '查看更多',
  'common.showLess': '收起',
  'common.noReplies': '暂无回复',
  'common.loading': '加载中...',
  'common.today': '今天',
  'common.justNow': '刚刚',
  'common.minAgo': '{count} 分钟前',
  'common.hrAgo': '{count} 小时前',
  'common.dayAgo': '{count} 天前',
  'common.dueToday': '今天到期',
  'common.dueTomorrow': '明天到期',
  'common.overdue': '逾期',

  // ── Instruction type labels ──
  'client.type.orderChange': '订单变更',
  'client.type.variation': '变更项',
  'client.type.approvalRequired': '需要审批',
  'client.type.instruction': '指示',
  'client.type.designDecision': '设计决策',
  'client.type.payment': '付款',
  'client.type.scheduleChange': '进度变更',
  'client.type.changeOrder': '变更单',

  // ── Instruction status labels ──
  'client.status.pending': '待处理',
  'client.status.sent': '已发送',
  'client.status.inProgress': '进行中',
  'client.status.approved': '已批准',
  'client.status.declined': '已拒绝',
  'client.status.clientApproved': '客户已批准',
  'client.status.clientDeclined': '客户已拒绝',
  'client.status.acknowledged': '已确认',
  'client.status.closed': '已关闭',
  'client.status.completed': '已完成',
  'client.status.awaitingApproval': '等待批准',
  'client.status.confirming': '待审核',

  // ── Payment status labels ──
  'client.payment.paid': '已付款',
  'client.payment.confirmed': '已确认',
  'client.payment.awaitingReview': '待审核',
  'client.payment.dueNow': '到期',
  'client.payment.overdue': '逾期',
  'client.payment.upcoming': '即将到来',
};

export default translations;